import { Route, Routes } from 'react-router-dom';

import RouteWithTitle from '../../../../src/routes/RouteWithTitle';
import {
  EmailConfigurationContextProvider as EmailContext,
  UserContextProvider as UserContext,
} from '../../../context';
import YahooSetup from '../../emailSettings/components/YahooSetup';
import CustomMail from '../components/CustomMail';
import EmailPreferences from '../components/emailPreferences/EmailPreferences';
import CreateSignature from '../components/emailSignature/CreateSignature';
import EmailSignature from '../components/emailSignature/EmailSignature';
import GmailSetup from '../components/GmailSetup';
import GoDaddySetup from '../components/GodaddySetup';
import MicrosoftSetup from '../components/MicrosoftSetup';
import ConfigureEmailSync from '../components/twoWayEmailSync/ConfigureEmailSync';
import WsDataLog from '../components/WsDataLog';
import EmailTemplatesList from '../EmailTemplatesList';

export const EmailSettings = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <RouteWithTitle title="Email Settings - Wisestep">
            <EmailContext>
              <GmailSetup />
            </EmailContext>
          </RouteWithTitle>
        }
      />
      <Route
        path="/microsoft"
        element={
          <EmailContext>
            <MicrosoftSetup />
          </EmailContext>
        }
      />
      <Route
        path="/yahoo"
        element={
          <EmailContext>
            <YahooSetup />
          </EmailContext>
        }
      />
      <Route
        path="/godaddy"
        element={
          <EmailContext>
            <GoDaddySetup />
          </EmailContext>
        }
      />
      <Route
        path="/custom-mail"
        element={
          <EmailContext>
            <CustomMail />
          </EmailContext>
        }
      />
      <Route
        path="/templates"
        element={
          <EmailContext>
            <EmailTemplatesList />
          </EmailContext>
        }
      />
      <Route
        path="/logs"
        element={
          <UserContext>
            <WsDataLog />
          </UserContext>
        }
      />
      <Route
        path="/preferences"
        element={
          <EmailContext>
            <EmailPreferences />
          </EmailContext>
        }
      />
      <Route
        path="/signature"
        element={
          <EmailContext>
            <EmailSignature />
          </EmailContext>
        }
      />
      <Route
        path="logs/inbox/"
        element={
          <UserContext>
            <WsDataLog />
          </UserContext>
        }
      />
      <Route
        path="logs/sent/"
        element={
          <UserContext>
            <RouteWithTitle title="Mail - Wisestep">
              <WsDataLog />
            </RouteWithTitle>
          </UserContext>
        }
      />
      <Route
        path="logs/campaigns/"
        element={
          <UserContext>
            <WsDataLog />
          </UserContext>
        }
      />
      <Route
        path="/signature/create"
        element={
          <EmailContext>
            <CreateSignature />
          </EmailContext>
        }
      />
      <Route
        path="/configure-email-inbox"
        element={
          <EmailContext>
            <ConfigureEmailSync />
          </EmailContext>
        }
      />
    </Routes>
  );
};
